import React from 'react';
import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Main from './main/Main';
import { ParallaxProvider } from 'react-scroll-parallax';
import AboutUs from "./aboutUs/AboutUs";
import Careers from "./careers/Careers";
import NfdPlatform from "./nfdPlatform/NfdPlatform";
import BrandAssets from "./brandAssets/BrandAssets";
import NfdTradeBots from "./nfdTradeBots/NfdTradeBots";
import Blog from "./blog/Blog";
import TermsConditions from "./termsConditions/TermsConditions";
import PrivacyPolicy from "./privacyPolicy/PrivacyPolicy";
import Article from "./article/Article";

function App() {
  return (
    <BrowserRouter>
      <ParallaxProvider>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/nfd-platform" element={<NfdPlatform />} />
          <Route path="/nfd-trade-bots" element={<NfdTradeBots />} />
          <Route path="/brand-assets" element={<BrandAssets />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/article/:slug" element={<Article />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </ParallaxProvider>
    </BrowserRouter>
  );
}

export default App;
